import { Analytics, checkPlacement } from 'client/Global/Analytics'
import { trackingFields } from 'client/Global/AnalyticsEvents'

export const addBlockedAccountAnalytics = (modifier: string) => {
  Analytics.trackEvent(trackingFields.name.blockedAccount, {
    type: trackingFields.type.modal,
    category: trackingFields.category.subscription,
    result: modifier,
    placement: checkPlacement(window.location.pathname),
  })
}
